import React from 'react';

export default ({ year, author, symbol = true }) => {
  const currentYear = new Date().getFullYear();
  const copyrightYear = isNaN(Number(year)) ? currentYear : Number(year);

  const copyrightNotice =
    currentYear !== copyrightYear
      ? `${copyrightYear}-${currentYear}`
      : copyrightYear;

  return (
    <span>
      {symbol ? '©' : 'Copyright'}&nbsp;{author}&nbsp;{copyrightNotice}
    </span>
  );
};
